import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bf1d3cfc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style1 from "./Index.vue?vue&type=style&index=1&id=bf1d3cfc&prod&scoped=true&lang=css"
import style2 from "./Index.vue?vue&type=style&index=2&id=bf1d3cfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.21_css-loader@6.11.0_webpack@5.101.3__lodash@4.17.21_kzgbr7tkrfh4tbz6eswufdvi6i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d3cfc",
  null
  
)

export default component.exports